/** @griffel:css-start [d] {"p":-1} **/
.f18qryls{padding-block:var(--spacingVerticalXXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ca9wz{color:var(--colorStatusDangerForeground1);}
.f1f8dvr7{border-top-color:var(--colorStatusDangerBorder1);}
.fo25q1j{border-bottom-color:var(--colorStatusDangerBorder1);}
.fu2xbgv{border-inline-start-color:var(--colorStatusDangerBorder1);}
.fceeiu4{border-inline-end-color:var(--colorStatusDangerBorder1);}
/** @griffel:css-end **/
/** @griffel:css-start [h] null **/
.f1c66vwv:hover{color:var(--colorStatusDangerForeground1);}
.f1usghc4:hover{background-color:var(--colorStatusDangerBackground1);}
.fl0aspu:hover{border-top-color:var(--colorStatusDangerBorder2);}
.f1p1a7ts:hover{border-bottom-color:var(--colorStatusDangerBorder2);}
.f16ooxjl:hover{border-inline-start-color:var(--colorStatusDangerBorder2);}
.f1e73890:hover{border-inline-end-color:var(--colorStatusDangerBorder2);}
/** @griffel:css-end **/